/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type ReactElement } from 'react';
import CheckoutFooter from '@/components/footer/checkout-footer';
import MainFooter, { type FooterContentSource } from '@/components/footer/main-footer';

interface FooterProps {
    variant?: 'full' | 'checkout';
    /** Footer blocks from the content assets (streamed by the `_app` loader); unused by checkout. */
    content?: FooterContentSource;
}

export default function Footer({ variant = 'full', content }: FooterProps): ReactElement {
    return variant === 'checkout' ? <CheckoutFooter /> : <MainFooter content={content} />;
}
